import * as React from 'react';

import {
  List,
  Create,
  Edit,
  SimpleForm,
  ReferenceField,
  Datagrid,
  TextField,
  DateField,
  BooleanInput,
  ReferenceInput,
  AutocompleteInput,
  required,
} from 'react-admin';

export const ManufacturerEmailDomainList = (props) => (
  <List {...props}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <ReferenceField
        label="Manufacturer"
        source="manufacturerId"
        reference="manufacturers"
      >
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField
        label="Email Domain"
        source="emaildomainId"
        reference="emaildomains"
      >
        <TextField source="email_domain" />
      </ReferenceField>
      <DateField source="createdAt" showTime />
      <DateField source="updatedAt" showTime />
    </Datagrid>
  </List>
);

export const ManufacturerEmailDomainCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <BooleanInput source="active" />
      <BooleanInput source="admin" />
      <ReferenceInput
        label="Email Domain"
        source="emaildomainId"
        reference="emaildomains"
        filterToQuery={(searchText) => ({ email_domain: searchText })}
        validate={required()}
      >
        <AutocompleteInput optionText="email_domain" />
      </ReferenceInput>
      <ReferenceInput
        label="Manufacturer"
        source="manufacturerId"
        reference="manufacturers"
        filterToQuery={(searchText) => ({ name: searchText })}
        validate={required()}
      >
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);

export const ManufacturerEmailDomainEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <BooleanInput source="active" />
      <BooleanInput source="admin" />
      <ReferenceInput
        label="Email Domain"
        source="emaildomainId"
        reference="emaildomains"
        filterToQuery={(searchText) => ({ email_domain: searchText })}
        validate={required()}
      >
        <AutocompleteInput optionText="email_domain" />
      </ReferenceInput>
      <ReferenceInput
        label="Manufacturer"
        source="manufacturerId"
        reference="manufacturers"
        filterToQuery={(searchText) => ({ name: searchText })}
        validate={required()}
      >
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
    </SimpleForm>
  </Edit>
);
